import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $("#client_avatar").filestyle({ buttonText: "Selecione uma imagem" });
  }
}
